<template>

	<div class="card" :class="{archived: thread.archived == 1}" v-on:click="threadClicked">
		<div class="card-body">
			<i v-if="hasNewMessage" class="fa fa-comment"></i>

			<div v-if="imageUrl" class="thread-image" :style="{backgroundImage: 'url(' + imageUrl + ')'}"></div>
			<div v-else class="thread-image" style="margin-bottom: 4px;">
				<i class="fa fa-user-circle fa-3x"></i>
			</div>
			<div class="card-content">
				<div v-if="thread.archived == 1" class="archive-tag">
					Archived
				</div>
				<h5 class="card-title">
					{{ thread.subject }}
					<div v-if="thread.is_comment_thread == 1" class="text-muted"><small>
						Comment Thread
					</small></div>
				</h5>
				<div class="d-flex justify-content-between card-text text-muted flex-wrap">
					<div>
						<span v-for="(member,index) in membersList">
							<last-active-indicator v-if="!('last' in member)" :last-active-utc="member.last_active" :user-id="member.id"></last-active-indicator>
							{{member.first_name}} {{member.last_name}}

							<span v-if="index < membersList.length-1 && !('last' in member)">, </span>
						</span>
						
					</div>
					<span>
						Last message {{ formatDateTimeToLocal(thread.last_message) }}
					</span>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import LastActiveIndicator from "@/components/LastActiveIndicator"

export default {

	name: 'MessageThreadCard',
	components: {
		LastActiveIndicator
	},
	props: ["thread","imageUrl","fullBleed"],
	computed: {
		hasNewMessage() {
			let vm = this

			if (this.$store.threadsWithNewMessages && this.$store.threadsWithNewMessages.indexOf(this.thread.id) >= 0) 
				return true

			else 
				return false
		},
		membersList() {
			let vm = this

			let showLimit = 5

			if (this.thread.Members.length > showLimit) {
				let sliced = this.thread.Members.slice(0,showLimit)

				sliced.push({
					first_name: " and ",
					last_name: (this.thread.Members.length - showLimit) + " others",
					last: true
				})

				return sliced
			}
			else
				return this.thread.Members
		}
	},
	methods: {
		threadClicked() {
			this.$emit("click",this.thread)
		}
	}

}
</script>

<style type="text/css" scoped>

	.card {
		margin-bottom: -1px;
		border-radius: 0;
	}

	.card.archived {
		background-color: #e0e0e0;
	}

	.card .archive-tag {
		position: absolute;
		top: 5px;
		right: 8px;
		font-size: 10pt;
	}

	.card-body {
		padding: 10px;
		padding-bottom: 5px;
		padding-top: 10px;
	}

	.card-body:hover {
		background-color: #e2ecf1;
		cursor: pointer;
	}

	.thread-image {
		width: 48px;
		height: 48px;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 50%;
		display: inline-block;
	}

	.card-title {
		margin: 0;
		font-size: 13pt;
	}

	.card-content {
		display: inline-block;
		vertical-align: top;
		width: calc(100% - 62px);
		margin-top: 5px;
		margin-left: 10px;
	}

	.card-text {
		font-size: 10pt;
	}

	.fa-comment {
		color: red;
		position: absolute;
		top: 5px;
		left: 45px;
	}

	@media (max-width: 550px) {
		.card {
			margin-left: -10px;
			margin-right: -8px;
			border-left: none;
			border-right: none;
			border-radius: 0;
		}
	}
</style>
